const emitir_relatorio_de_docentes_com_informacoes_pendentes = [
  {
    path: "/emitir-relatorio-de-docentes-com-informacoes-pendentes",
    name: "emitir_relatorio_de_docentes_com_informacoes_pendentes",
    meta: {
      breadCrumb:
        "Censo Escolar - Relatório de Acompanhamento do Censo Escolar",
      allowedPermissions: ["relatorios_servidor_informacoes_pendentes"],
    },
    component: () =>
      import(
        "@/views/EmitirRelatorioDeDocentesComInformacoesPendentes/EmitirRelatorioDeDocentesComInformacoesPendentes.vue"
      ),
  },
];

export { emitir_relatorio_de_docentes_com_informacoes_pendentes };
